import { render, staticRenderFns } from "./Affiliations.vue?vue&type=template&id=7e33bbe0&scoped=true"
import script from "./Affiliations.vue?vue&type=script&lang=js"
export * from "./Affiliations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e33bbe0",
  null
  
)

export default component.exports